import React, { Component } from 'react';
import { connect } from 'react-redux';
import { employeeViewCrumb } from 'utils/breadcrumbInfo';
import { splitWords } from 'utils/helpers';
import { getPatientOrders, getEmployeeDetails, getShiftsFilter, resetEmployeeList } from 'actions/EntityActions';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';

import Header from "./Components/Header";
import EmployeeViewMenu from './Components/EmployeeViewMenu';
import "./employeeStyle.scss"

const compName = "EmployeeView"

class EmployeeView extends Component {
    constructor(props) {

        super(props);

        this.state = {
            orders: {
                activePage: 1,
                itemsPerPage: 10
            },
            shifts: {
                activePage: 1,
                itemsPerPage: 10
            },
            display: 'view',
            tabs: {
                value: "info"
            }
        }

        this.changePage = this.changePage.bind(this);
        this.loadOrders = this.loadOrders.bind(this);
        this.loadShifts = this.loadShifts.bind(this);

    }

    getEmployeeId() {
        const { state } = this.props.location || {};
        const idFromState = state && state.id || null;
        const pathname = window.location.pathname;
        const idFromUrl = pathname.split('/employee/')[1] || null;

        return idFromState || idFromUrl;
    }

    componentWillMount() {

        this.getEmployee();
    }

    componentWillUnmount() {
        this.props.resetEmployeeList();
    }

    handleTabs = (value) => {
        this.setState(prevState => ({
            tabs: {
                ...prevState.tabs,
                value: value
            }
        }));
    }

    getEmployee() {
        const id = this.getEmployeeId();
        const model = {
            id: id,
            branchId: this.props.branchId,
            compName: compName
        }
        this.props.getEmployeeDetails(model);
    }

    getShiftsFilter() {
        const id = this.getEmployeeId();
        const model = {
            firstName: "",
            lastName: "",
            Date: null,
            status: "None",
            employeeId: id,
            orderBy: "DESC",
            sortBy: "PunchInDate",
            page: this.state.shifts.activePage,
            itemsPerPage: this.state.shifts.itemsPerPage
        }

        this.props.getShiftsFilter(model);
    }

    loadShifts() {
        if (this.props.employeeShiftList.list.length === 0) {
            this.getShiftsFilter();
        }
    }

    getOrders() {
        const id = this.getEmployeeId();
        const model = {
            orderNumber: null,
            orderDate: null,
            patientFirstName: "",
            employeeFirstName: "",
            status: 'None',
            total: null,
            orderBy: "DESC",
            sortBy: "Id",
            innerClass: "",
            employeeId: id,
            patientId: null,
            page: this.state.orders.activePage,
            itemsPerPage: this.state.orders.itemsPerPage
        }

        this.props.getEmployeeOrders(model);
    }

    loadOrders() {
        if (!this.props.employeeOrders.hasOwnProperty('list')) {
            this.getOrders();
        }
    }

    changePage = (page, compName) => {
        if (compName === 'shifts') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    shifts: {
                        ...prevState.shifts,
                        activePage: page
                    }
                };
            }, () => this.getShiftsFilter());
        }

        if (compName === 'orders') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    orders: {
                        ...prevState.orders,
                        activePage: page
                    }
                };
            }, () => this.getOrders());
        }
    }

    render() {
        const employee = this.props.employeeDetails;

        const orders = {
            orders: this.props.employeeOrders,
            pagination: {
                ...this.state.orders
            }
        }

        const shifts = {
            shifts: this.props.employeeShiftList,
            pagination: {
                ...this.state.shifts
            }
        }

        const employeeHeader = {
            fullName: this.props.employeeDetails.fullName || "",
            role: splitWords(this.props.employeeDetails.roleLabel || "") || "",
            id: this.props.employeeDetails.id || "",
            totalSales: this.props.employeeDetails.totalSales > 0 ? this.props.employeeDetails.totalSales : 0,
            completedOrders: this.props.employeeDetails.completedOrders > 0 ? this.props.employeeDetails.completedOrders : 0,
            lastShift: this.props.employeeDetails.lastShift || "",
            pin: this.props.employeeDetails.pin ? this.props.employeeDetails.pin : "No Pin",
            canUpdateEmployee: this.props.canUpdateEmployee
        }

        return (
            <div id="employee_view" className='employee-detail-container'>
                <Grid headerContent={employeeViewCrumb}>
                    <CardSimple>
                        <div className="container-fluid profile-view-container">
                            <div className="row m-0">
                                <Header {...employeeHeader} />
                            </div>
                            {/* Menu */}
                            <EmployeeViewMenu
                                employeeInfo={employee}
                                orders={orders}
                                shifts={shifts}
                                loadOrder={this.loadOrders}
                                changePage={this.changePage}
                                handleTabs={this.handleTabs}
                                tabValue={this.state.tabs.value}
                            />
                        </div>
                    </CardSimple>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        employeeDetails: state.entity.employeeDetails,
        employeeOrders: state.entity.patientOrders,
        employeeShiftList: { list: state.entity.shiftsListFilter, total: state.entity.shiftsListFilterLength },
        canUpdateEmployee: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanUpdateEmployee"))
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getEmployeeDetails: (model) => dispatch(getEmployeeDetails(model)),
        getEmployeeOrders: (model) => dispatch(getPatientOrders(model)),
        getShiftsFilter: (model) => dispatch(getShiftsFilter(model)),
        resetEmployeeList: () => dispatch(resetEmployeeList())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeView);
